import React from 'react'
export default function ChevronIcon() {
    return (
       <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.5 1V12M11.5 12L6.5 6.5M11.5 12L16.5 6.5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M1.5 11V17H21.5V11" stroke="black" fill='none' stroke-width="2" stroke-linecap="round"/>
        </svg>
    )
}





